module.exports = __webpack_public_path__ + "assets/article.9f6fbc85.jpg";